import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import PageLayout from "../components/layout/PageLayout";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import { fetchWithAuth } from "../Context/UserContext";
import API_URL from "../config";
import { Card, CardContent } from "../components/ui/card";

const StatTile = ({ label, value }) => (
  <Card>
    <CardContent className="pt-6">
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-foreground">{value}</p>
    </CardContent>
  </Card>
);

const StaffMetrics = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetchWithAuth(`${API_URL}/bs/staff/marketplace-stats`);
        if (response.ok) {
          setStats(await response.json());
        } else {
          const data = await response.json();
          setError(data.error || "No tienes acceso a esta sección.");
        }
      } catch (err) {
        console.error("Error al cargar las métricas de marketplace:", err);
        setError("Error en la conexión con el servidor.");
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <LoadingOverlay />;
  }

  return (
    <PageLayout>
      <Helmet>
        <title>Métricas de marketplace - Procu</title>
      </Helmet>

      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
        <h1 className="text-2xl font-semibold text-foreground">Métricas de marketplace</h1>
        <p className="text-sm text-muted-foreground">
          Solo visible para el equipo de Procu.
        </p>

        {error && <p className="mt-6 text-sm text-destructive">{error}</p>}

        {stats && (
          <>
            <h2 className="mt-8 text-sm font-semibold text-foreground">
              Embudo de invitación a licitación
            </h2>
            <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <StatTile label="Invitaciones enviadas" value={stats.invitaciones.total} />
              <StatTile
                label="Registrados"
                value={`${stats.invitaciones.registrados} (${stats.invitaciones.tasa_registro}%)`}
              />
              <StatTile
                label="Enviaron cotización"
                value={`${stats.invitaciones.aplicados} (${stats.invitaciones.tasa_aplicacion}%)`}
              />
              <StatTile
                label="Horas hasta primera cotización"
                value={stats.tiempo_promedio_a_primera_cotizacion_horas ?? "Sin datos"}
              />
            </div>

            <h2 className="mt-8 text-sm font-semibold text-foreground">
              Adquisición de oferta para el marketplace
            </h2>
            <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <StatTile
                label="Empresas invitadas que postularon a otra licitación"
                value={`${stats.tasa_reingreso_otra_licitacion}%`}
              />
            </div>

            <h2 className="mt-8 text-sm font-semibold text-foreground">
              Certificados vs no certificados
            </h2>
            <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <StatTile
                label="Tasa de adjudicación — certificados"
                value={`${stats.certificacion.con_certificado.tasa_adjudicacion}% (${stats.certificacion.con_certificado.postulaciones} postulaciones)`}
              />
              <StatTile
                label="Tasa de adjudicación — no certificados"
                value={`${stats.certificacion.sin_certificado.tasa_adjudicacion}% (${stats.certificacion.sin_certificado.postulaciones} postulaciones)`}
              />
            </div>
          </>
        )}
      </div>
    </PageLayout>
  );
};

export default StaffMetrics;
